import { memo, useEffect, useRef } from 'react';
import { IColor } from '../../interfaces';

interface IFormColorControl {
    rgbaColor: IColor,
    onChange: (color: IColor) => void,
}

/**
 * Color Picker Control.
 */
const FormColorControl = (props: IFormColorControl) => {

    const { rgbaColor, onChange } = props;

    const colorPickerRef = useRef<HTMLElement>();

    useEffect(() => {

        const colorPicker = colorPickerRef.current;

        const onColorChange = (evt: Event) => {
            const customEvent = evt as CustomEvent;
            onChange(customEvent.detail.color.toRgb());
        };

        colorPicker?.addEventListener('change', onColorChange);

        return () => {
            colorPicker?.removeEventListener('change', onColorChange);
        };
    }, [onChange]);

    return (
        <toolcool-color-picker
            ref={ colorPickerRef }
            color={`rgba(${ rgbaColor.r }, ${ rgbaColor.g }, ${ rgbaColor.b }, ${ rgbaColor.a })`} />
    )
};

export default memo(FormColorControl);